import React, { lazy, Suspense } from 'react';
import { LoadingSpinner } from '@miroculus/miroculus-ui';
const ProtocolSelection = lazy(() => import(
/* webpackChunkName: 'protocol-selection' */
'./ProtocolSelection'));
const loading = React.createElement(LoadingSpinner, { message: "Loading protocols..." });
const ProtocolSelectionLoader = () => (React.createElement(Suspense, { fallback: loading },
    React.createElement(ProtocolSelection, null)));
export default ProtocolSelectionLoader;
